import { gql } from "@apollo/client";

export const GET_RUNNER_STATS = gql`
  query getRunnerStats($wagerProfile: String!, $entityRunnerId: String!) {
    runnerStats(profile: $wagerProfile, entityRunnerId: $entityRunnerId) {
      numberRaces
      numberRacesWon
      numberRacesTop3
    }
  }
`;

export default GET_RUNNER_STATS;
